import { guestClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  ProveActionRequestSchema,
  RecoQuerySchema,
  RecommendationResponseSchema,
} from './schemas.js';

export const applyRecommendation = guestClient.mutation({
  url: 'recommendations/notifications/platforms/confirm' as const,
  method: 'POST',
  responseSchema: z.object({}),
  querySchema: RecoQuerySchema,
  processResponse(data) {
    return data;
  },
});

export const getRecommendation = guestClient.query({
  url: 'recommendations/notifications/platforms/landing' as const,
  method: 'GET',
  responseSchema: RecommendationResponseSchema,
  querySchema: RecoQuerySchema,
  processResponse(data) {
    const { recommendation, clientName, platformName } = data;
    return { ...recommendation, clientName, platformName };
  },
});

export const proveAction = guestClient.mutation({
  url: 'recommendations/notifications/platforms/actions' as const,
  method: 'POST',
  querySchema: RecoQuerySchema,
  requestSchema: ProveActionRequestSchema,
  responseSchema: z.object({}),
  processResponse(data) {
    return data;
  },
});
